
import React from "react";
import { Button } from "@/components/ui/button";

type Props = {
  retryCount: number;
  onRetry: () => void;
};

const Step2NumberLoading: React.FC<Props> = ({ retryCount, onRetry }) => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4"></div>
    <p>Loading your existing phone numbers...</p>
    {retryCount > 0 && (
      <Button 
        onClick={onRetry}
        variant="outline"
        className="mt-4"
      >
        Retry
      </Button>
    )}
  </div>
);

export default Step2NumberLoading;
